import type { SVGProps } from "react"
const ShieldPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M12.4 3.767a1 1 0 0 0-.8 0l-6 2.625a1 1 0 0 0-.6.916V13c0 1.714.616 3.283 1.638 4.5A6.985 6.985 0 0 1 12 15c2.153 0 4.078.972 5.362 2.5A6.971 6.971 0 0 0 19 13V7.308a1 1 0 0 0-.6-.916l-6-2.625Zm3.47 15.067A4.99 4.99 0 0 0 12 17a4.99 4.99 0 0 0-3.87 1.834A6.968 6.968 0 0 0 12 20c1.43 0 2.761-.43 3.87-1.166Zm-5.072-16.9a3 3 0 0 1 2.405 0l6 2.626A3 3 0 0 1 21 7.308V13a9 9 0 1 1-18 0V7.308A3 3 0 0 1 4.798 4.56l6-2.625ZM12 8.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Zm-3.75 1.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z"
      clipRule="evenodd"
    />
  </svg>
)
export default ShieldPerson
